module.exports = __webpack_public_path__ + "img/3.bacd3665.jpg";